// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useMemo } from 'react';
import ActivityEditMobileActions from '../ActivityEditMobileAction';
import CollapsableItem from '../../utils/CollapsableItem';
import ActivityMobileSwitchField from '../ActivityForm/ActivityMobileSwitchField';
import ActivityFormMultiSelectMobile from '../ActivityForm/ActivityFormMultiSelector/ActivityFormMultiSelectMobile';

const ActivityTagFieldsMobile = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  selectedTags,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  allTags,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onSaveClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onResetClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  disabled,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);

  const onTagChange = tag => {
    let newTags = [];
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (selectedTags.includes(tag)) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      newTags = selectedTags.filter(t => t !== tag);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      newTags = [...selectedTags, tag];
    }
    onChange(newTags);
  };

  const getOtherTags = tagsList =>
    tagsList.filter(
      tag => tag !== 'hidden' && tag !== 'featured' && tag !== 'bookable'
    );

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const otherAllTags = useMemo(() => getOtherTags(allTags), [allTags.length]);

  return (
    <div className='data-box'>
      <h4 className='header' style={{ display: 'flex', alignItems: 'center' }}>
        Tags
        <ActivityEditMobileActions
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          onSaveClick={onSaveClick}
          onResetClick={onResetClick}
          disabled={disabled}
        />
      </h4>
      <CollapsableItem>
        <ActivityMobileSwitchField
          label='Hidden'
          name='hidden'
          onChange={onTagChange}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          checked={!!selectedTags.find(tag => tag === 'hidden')}
          isEditMode={isEditMode}
        />
        <ActivityMobileSwitchField
          label='Featured'
          name='featured'
          onChange={onTagChange}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          checked={!!selectedTags.find(tag => tag === 'featured')}
          isEditMode={isEditMode}
        />
        <ActivityMobileSwitchField
          label='Bookable'
          name='bookable'
          onChange={onTagChange}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          checked={!!selectedTags.find(tag => tag === 'bookable')}
          isEditMode={isEditMode}
        />
        <ActivityFormMultiSelectMobile
          label='All'
          selectedItems={selectedTags}
          options={otherAllTags}
          onItemClick={onTagChange}
          isEditMode={isEditMode}
        />
      </CollapsableItem>
    </div>
  );
};

export default ActivityTagFieldsMobile;
